<template>
  <div id="ca-chipsbar">
    <template v-for="(item, i) in items">
      <ca-chip
        :key="i"
        :item="item"
        :dark="!!item.dark"
        :cantidad_bold="cantidad_bold"
        :invertir="chips_invertidos"
        :boton_cerrar="boton_cerrar"
        :disabled="disabled_chips"
        @close="$emit('close', item)"
        @click="$emit('click', item)"
        :texto_cierre="texto_cierre"
      >
        <template slot="izquierda">
          <slot name="izquierda-chips" :item="item"></slot>
        </template>

        <template slot="cantidad">
          <slot name="cantidad-chips" :item="item"></slot>
        </template>

        <template slot="default">
          <slot :item="item"></slot>
        </template>
      </ca-chip>
    </template>
  </div>
</template>

<script>
/**
   Barra de Chips
   Componente utilizado para mostrar informacion de cantidades y montos para items
   Utiliza chips de Vuetify (v-chip).
   Formato prop items:
   [
   {
   *   label: <string>, Label a mostrar antes del monto (se ignora key)
   *   cant: <number> (opcional), Cantidad representativa del string obtenido a partir de key
   *   key: <string>, Clave utilizada para buscar en el diccionario singulares y plurales segun corresponda
   *   prefix: <string> (opcional) prefijo que antecederá a la traducción obtenida del diccionario
   *   suffix: <string> (opcional) sufijo aplicado a la traducción obtenida del diccionario
   *   forzar_plurales: <boolean> se fuerza la traducción del label a su versión en plural
   *   monto: <number> (opcional) cuando el item posee un monto, por ejemplo para gastos
   *   opcional: <boolean> Indica que el chip es opcional, es decir que no se muestra para cantidad menor igual a 0
   },
   <otro chip>
   ]
   Ademas posee los siguientes scoped slots con la prop item (chip actual)
   <izquierda>
   <cantidad>
   Y un slot default para mostrar un label
   */

export default {
  props: {
    items: {type: Array, default: () => []},
    // Propiedades propias de la estilización de los chips
    cantidad_bold: {type: Boolean, default: false}, // La cantidad se muestra en negrita
    dark: {type: Boolean, default: false}, // Los ca-chips serán oscuros
    chips_invertidos: {type: Boolean, default: false}, // Se invierte el orden entre el label y las cantidades
    boton_cerrar: {type: Boolean, default: false}, // Agrega boton de cerrar a cada chip
    disabled_chips: {type: Boolean, default: true},
    texto_cierre: {type: String, default: ''}
  }
};
</script>

<style lang="scss">
  #ca-chipsbar {
    .ca-chip {
      .v-chip__content {
        max-height: 28px;
      }
    }
  }
</style>